<svg
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	aria-hidden="true"
	role="img"
	class="iconify iconify--carbon"
	width="100%"
	height="100%"
	preserveAspectRatio="xMidYMid meet"
	viewBox="0 0 32 32"
>
	<circle cx="20" cy="4" r="2" fill="currentColor" />
	<circle cx="8" cy="16" r="2" fill="currentColor" />
	<circle cx="28" cy="12" r="2" fill="currentColor" />
	<circle cx="11" cy="7" r="2" fill="currentColor" />
	<circle cx="16" cy="24" r="2" fill="currentColor" />
	<path
		fill="currentColor"
		d="M30 3.413L28.586 2L4 26.585V2H2v26a2 2 0 0 0 2 2h26v-2H5.413Z"
	/>
</svg>
